module.exports = __webpack_public_path__ + "img/benefits_equipment.9018271.svg?v=1750420299372";